import { styled } from "@mui/material";
import { Panel } from "shipnow-mercurio";

export const CenteredPanel = styled(Panel)({
  margin: "0 auto",
});

export const Styles = {
  CenteredPanel,
};
